// extracted by mini-css-extract-plugin
export default {"app-brand":"app-brand-ikRqExc"};